/*
 * @Description: 业务参数数据获取
 * @Author: mdb
 * @Date: 2022-07-15 11:07:07
 * @LastEditTime: 2023-03-06 11:21:57
 * @LastEditors: mdb
 */
import { useRequest } from 'vue-request'
import { listByParamCodes } from '@/api/common'
import type { ParamCodeItem } from '@/typings/common'

type AppIdType = 'cos_fbu' | 'cos_ofbu' | 'cos_lbu' | 'cos_zbu'
interface ParamCodeResult {
  [key: string]: ParamCodeItem[]
}

// 获取业务参数数据
const getParamCodes = (appId: AppIdType, paramCodes: string | string[]): Promise<ParamCodeResult> => {
  return new Promise((resolve, reject) => {
    const paramCodeList = Array.isArray(paramCodes) ? paramCodes : [paramCodes]
    const cacheKey = `${appId}-${paramCodeList.join('-')}`
    useRequest(listByParamCodes, {
      defaultParams: [{ appId, paramCodes: paramCodeList }],
      cacheKey,
      // cacheTime: 10 * 60 * 1000, // 10 minutes
      // staleTime: 10 * 60 * 1000, // 10 minutes
      onSuccess(data) {
        resolve(data.data)
      },
      onError(Error) {
        reject(Error)
      }
    })
  })
}

export default function () {
  return { getParamCodes }
}
